<template>
  <div>
    <textarea
      class="form-control"
      :class="{ 'is-invalid': hasErrors }"
      :name="attribute.name"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :rows="rows"
      :disabled="disabled"
    ></textarea>
    <div
      v-if="attribute.errors !== null"
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>

<script lang="babel">
export default {
  props: {
    value: {
      required: true,
    },
    attribute: {
      required: true,
      type: Object,
    }
  },
  mounted() {
    this.modelValue = this.value;
  },
  data() {
    return {
      modelValue: "",
    };
  },
  computed: {
    hasErrors() {
      return this.attribute.errors.length !== 0;
    },
    rows() {
      return this.attribute.rows === undefined ? 3 : this.attribute.rows;
    },
    disabled() {
      return Boolean(this.attribute.disabled);
    }
  }
}
</script>
